export default {"src":"/_next/static/media/logo-2.c5f3cb4f.svg","height":119,"width":129,"blurWidth":0,"blurHeight":0};